import { useTheme } from '~/hooks/use-theme'
import type { TIconProps, TIconSizes } from '../types'

export function useIconProps({
  size = 'small',
  color = 'colorTextNeutralDefault',
}: Omit<TIconProps, 'symbol'>) {
  const theme = useTheme()

  const iconSizeMapping: Record<TIconSizes, number> = {
    tiny: theme.sizingTiny,
    'extra-small': theme.sizingExtrasmall,
    small: theme.sizingSmall,
    medium: theme.sizingMedium,
  }

  const iconColorMapping = theme[color]

  return {
    size: iconSizeMapping[size],
    color: iconColorMapping,
  }
}
